import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {Select} from "antd";
import ApiService from "../../core/service/ApiService";
import usePermissionGuard from "./usePermissionGuard";

export default function RoleSelectBox(props)
{
    const {t} = useTranslation();

    const [roles, setRoles] = useState([])
    const { canGrant } = usePermissionGuard();

    const getRoles = async () =>
    {
        const response = await ApiService.Role.GetRoleList();
        if (response.success)
        {
            setRoles(response.data)
        }
    }

    useEffect(() => {
        getRoles()
    }, [])

    return (
        <>
            <Select
                mode="single"
                allowClear
                // Kendinden fazla yetki içeren rol seçilemez (süper admin hariç)
                options={roles.map(r => ({ ...r, disabled: !canGrant(r.permissionIdList) }))}
                fieldNames={{
                    label: 'name',
                    value: 'id'
                }}
                {...props}
            />
        </>
    )
}
